/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import {useEffect, useState} from 'react';
import {AppHomeUCSData} from '../containers/AppHome/types';
import UserContentService from '../services/UserContentService';

// Reference for this paradigm: https://levelup.gitconnected.com/react-hooks-gotchas-setstate-in-async-effects-d2fd84b02305
type PromiseState =
	| { status: 'idle' | 'pending'; value: null; error: null }
	| { status: 'fulfilled'; value: AppHomeUCSData; error: null }
	| { status: 'rejected'; value: null; error: Error };

/**
 * Method to fetch data for category page.
 *
 */
export default function FetchAppHomeData(appContextType: string) {
	const [appHomesState, setAppHomesState] = useState<PromiseState>({
		status: 'pending',
		value: null,
		error: null,
	});

	useEffect(() => {
		const appHomesResponse = async() => {
			const userContentService = new UserContentService();
			const response = await userContentService.fetchAppHomes(appContextType);

			if (response instanceof Error) {
				setAppHomesState({
					status: 'rejected',
					value: null,
					error: response,
				});
			}
			else {
				setAppHomesState({
					status: 'fulfilled',
					value: response,
					error: null,
				});
			}
		};
		if (appHomesState.status === 'pending') {
			// OR appHomesState.value === null ?
			appHomesResponse();
		}
	}, [appContextType]);

	return appHomesState;
}
